import { useAppContext } from "@context/app";
import { useLayoutContext } from "@context/layout";
import Close from "@svg/close";
import { separateMoneyNumbers, toFarsiNumber } from "@utils/digits";
import React, { FC } from "react";
import { Button, BUTTON_SIZE } from "../button";

interface Props {
  onClose: () => void;
  showAppDownload: () => void;
}

const Banner: FC<Props> = ({ onClose, showAppDownload }) => {
  const { hideFooter, hideAppBanner } = useAppContext();
  const { staticData } = useLayoutContext();

  if (hideFooter || hideAppBanner) return null;
  const productTime = `${separateMoneyNumbers(
    toFarsiNumber(staticData?.statistics?.sumOfProductTimes)
  )} ساعت آموزش`;
  return (
    <div
      className="fixed md:bottom-0 bottom-16 overflow-hidden w-full z-30  pointer-events-auto inset-x-0 h-12 px-4 py-2 bg-[#0C365C]"
      onClick={showAppDownload}
    >
      <div className="flex items-center justify-between ">
        <div className="flex items-center gap-x-7 ">
          <Button
            size={BUTTON_SIZE.MEDIUM}
            className="w-11"
            onClick={showAppDownload}
          >
            دانلود
          </Button>
          <p className="text-xs font-bold text-white leading-5">
            {productTime}
            <span className="font-medium"> در اپلیکیشن فرادرس</span>
          </p>
        </div>

        <Close
          className="cursor-pointer h-4 w-4"
          fill="#A1A1AA"
          onClick={onClose}
        />
      </div>
    </div>
  );
};

export default Banner;
